import { useSyncExternalStore } from "react";

let loading = false;
const listeners = new Set<() => void>();

const publish = (next: boolean) => {
  loading = next;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const startRouteLoading = () => publish(true);
export const finishRouteLoading = () => publish(false);

export const useRouteLoading = (): boolean => useSyncExternalStore(subscribe, () => loading);
